var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import { useCallback } from 'react';
import { api, apiResolve, useApiPost } from '@sierralabs/core-ui';
export function createFile(dto) {
    return apiResolve(api.post('files', dto));
}
export function useCreateFile() {
    const _a = useApiPost('files'), { post } = _a, result = __rest(_a, ["post"]);
    const createFile = useCallback((dto) => post(dto), [post]);
    return Object.assign(Object.assign({}, result), { createFile });
}
//# sourceMappingURL=useCreateFile.js.map